import * as React from "react";
import * as PropTypes from "prop-types";
import { HoverDropdown } from "../Dropdown";
import { NavItemPropTypes } from "../../vars";
import NavbarDropdownLabel from "./NavbarDropdownLabel";
import NavbarDropdownLabelWrapper from "./NavbarDropdownLabelWrapper";
import NavbarDropdownMenu from "./NavbarDropdownMenu";
import NavbarDropdownMenuItem from "./NavbarDropdownMenuItem";
import NavbarDropdownMenuButton from "./NavbarDropdownMenuButton";

class NavbarDropdown extends React.Component<any, any> {
  static propTypes = {
    children: PropTypes.string.isRequired,
    menuItems: NavItemPropTypes.menuItems,
  };

  static defaultProps = {
    menuItems: [],
  };

  renderDropdownMenu = (menuItems, menuId) => (
    <NavbarDropdownMenu menuName={menuId}>
      {menuItems.map((item, index) => {
        if (item.onClick) {
          return (
            <NavbarDropdownMenuButton
              key={index + item.label}
              onClick={item.onClick}
            >
              {item.label}
            </NavbarDropdownMenuButton>
          );
        } else {
          return (
            <NavbarDropdownMenuItem
              parentMenuId={menuId}
              href={item.href}
              key={index + item.label}
              disableTracking={item.disableTracking}
            >
              {item.label}
            </NavbarDropdownMenuItem>
          );
        }
      })}
    </NavbarDropdownMenu>
  );

  render() {
    const {
      children,
      className,
      icon,
      menuItems,
      menuId,
      menuLabel,
    } = this.props;

    const dropdownMenu = this.renderDropdownMenu(menuItems, menuId);

    return (
      <HoverDropdown
        menu={dropdownMenu}
        className={className}
        role="menu"
        aria-label={menuLabel}
      >
        <NavbarDropdownLabelWrapper>
          {icon && <i className="md-icon symbol">{icon}</i>}
          <NavbarDropdownLabel>{children}</NavbarDropdownLabel>
          <i className="md-icon chevron">keyboard_arrow_down</i>
        </NavbarDropdownLabelWrapper>
      </HoverDropdown>
    );
  }
}

export default NavbarDropdown;
